import { EMPTY_VALUE } from '@src/core/config';
import { UnitType } from '@src/core/enums';
import { getUnitType } from '@src/core/features/settings/units';

export const arcTemperatureUnit = (unitType: UnitType = getUnitType()) => {
  if (unitType === UnitType.SI) return '°C';
  if (unitType === UnitType.IMPERIAL) return '°F';
  return '';
};

export const arcTemperature = (
  value?: number | null,
  options?: { unitType?: UnitType; fromSi?: boolean },
) => {
  const payload = Number(value);
  if (isNaN(payload)) return EMPTY_VALUE;

  const displayUnit = options?.unitType ?? getUnitType();
  const unit = arcTemperatureUnit(displayUnit);
  if (!unit) return EMPTY_VALUE;

  let display = payload;
  if (options?.fromSi && displayUnit === UnitType.IMPERIAL) {
    display = payload * 9 / 5 + 32;
  }

  return `${Math.round(display)} ${unit}`;
};
